import { webVitalsReport180 as webVitalsReport } from '@wix/bi-logger-pulse/v2';
import { normalizeUrl } from './url';
import { toPulseMetric } from './pulse-metric';
export default class Queue {
    // Internal business logic
    _map = new Map();
    _biLogger;
    _pulseLogger;
    // Data added to the event
    _navigationId;
    _navType;
    _url;
    _platform;
    _sessionId;
    _vsi;
    _msid;
    _uuid;
    // Public properties
    getHtmlElementMetadata = () => ({});
    constructor({ url, platform, biLogger, pulseLogger, navigationId, navType, sessionId, vsi, msid, uuid, getHtmlElementMetadata, }) {
        this._url = normalizeUrl(url);
        this._platform = platform;
        this._biLogger = biLogger;
        this._pulseLogger = pulseLogger;
        this._navigationId = navigationId;
        this._navType = navType;
        this._sessionId = sessionId;
        this._vsi = vsi;
        this._msid = msid;
        this._uuid = uuid;
        // Initialize public properties
        this.getHtmlElementMetadata = getHtmlElementMetadata;
    }
    flushQueue() {
        if (this._map.size > 0) {
            // We want to avoid throwing uncaught exceptions since we're running in the platform.
            try {
                let webVitals = {};
                const metadataObject = {};
                for (const [metricName, pulseMetric] of this._map.entries()) {
                    const { metadata: metricMetadata, ...rest } = pulseMetric;
                    if (Object.keys(metricMetadata).length > 0) {
                        metadataObject[metricName] = metricMetadata;
                    }
                    webVitals = {
                        ...webVitals,
                        ...rest,
                    };
                }
                const metadata = JSON.stringify(metadataObject);
                const event = webVitalsReport({
                    platform: this._platform,
                    url: this._url,
                    navigationId: this._navigationId,
                    navType: this._navType,
                    ...webVitals,
                    metadata,
                    sessionId: this._sessionId,
                    ...(this._msid && { msid: this._msid }),
                    ...(this._vsi && { vsi: this._vsi }),
                    ...(this._uuid && { uuid: this._uuid }),
                });
                // https://github.com/wix-private/bi-logger/blob/master/bi-logger-client/lib/bi-logger.js#L42
                const { src, evid, params, ...context } = event;
                const logParams = { src, evid, ...params };
                const logContext = { ...context, category: 'essential' };
                // @ts-expect-error We are avoiding importing the bi-logger package
                this._biLogger.log(logParams, logContext);
                this._pulseLogger.info('Flushing queue', event);
            }
            catch (e) {
                this._pulseLogger.error('Failed to flush queue', e);
            }
            this._map.clear();
        }
    }
    addToQueue(metric) {
        this._pulseLogger.info(`Adding metric to queue: ${metric.name}`, metric);
        this._map.set(metric.name, toPulseMetric(metric, this.getHtmlElementMetadata));
    }
}
//# sourceMappingURL=queue.js.map